const KL_MIX_MATCH_SELECTOR = '[data-kl-mix-match]';
const KL_MIX_MATCH_BUTTON_SELECTOR = '[data-kl-mix-match-add]';
const KL_MIX_MATCH_ERROR_SELECTOR = '[data-kl-mix-match-error-message]';

function getCartElement(cartElementName) {
  return cartElementName ? document.querySelector(cartElementName) : null;
}

function buildAddRequest(variantId, cartElement, pathname) {
  const body = { id: variantId, quantity: 1 };
  const sections = cartElement?.getSectionsToRender?.().map((section) => section.id);

  if (sections?.length) {
    body.sections = sections;
    body.sections_url = pathname;
  }

  return body;
}

function setButtonBusy(button, isBusy) {
  button.setAttribute('aria-busy', String(isBusy));
  button.disabled = isBusy;
}

function setErrorMessage(root, message) {
  const target = root.querySelector(KL_MIX_MATCH_ERROR_SELECTOR);

  if (target) target.textContent = message;
}

function announceCartUpdate(variantId, cartData) {
  if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kl-mix-match', productVariantId: variantId, cartData });
}

async function addMixMatchProduct(root, button) {
  const {
    klMixMatchVariant: variantId,
    klMixMatchAddUrl: addUrl,
    klMixMatchCartUrl: cartUrl,
    klMixMatchCartElement: cartElementName,
  } = root.dataset;

  if (!variantId || !addUrl) throw new Error('Mix & Match is missing its variant or cart route');

  const cartElement = getCartElement(cartElementName);

  cartElement?.setActiveElement?.(button);

  const response = await fetch(`${addUrl}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(buildAddRequest(variantId, cartElement, document.location.pathname)),
  });

  const cartData = await response.json();

  if (!response.ok) throw new Error(cartData?.description || cartData?.message || `Add failed (${response.status})`);

  if (!cartElement) {
    document.location = cartUrl;
    return;
  }

  cartElement.classList.remove('is-empty');
  cartElement.renderContents(cartData);
  announceCartUpdate(variantId, cartData);
}

function initMixMatch(root) {
  if (!root || root.dataset.klMixMatchReady === 'true') return;

  const button = root.querySelector(KL_MIX_MATCH_BUTTON_SELECTOR);

  if (!button) {
    console.debug('kl-mix-match: the block has no add button', { variantId: root.dataset.klMixMatchVariant });
    return;
  }

  root.dataset.klMixMatchReady = 'true';

  button.addEventListener('click', async () => {
    if (button.getAttribute('aria-busy') === 'true') return;

    setErrorMessage(root, '');
    setButtonBusy(button, true);

    try {
      await addMixMatchProduct(root, button);
    } catch (error) {
      console.debug('kl-mix-match: the companion product could not be added', {
        variantId: root.dataset.klMixMatchVariant,
        error,
      });
      setErrorMessage(root, root.dataset.klMixMatchError || '');
    } finally {
      setButtonBusy(button, false);
    }
  });
}

document.querySelectorAll(KL_MIX_MATCH_SELECTOR).forEach(initMixMatch);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(KL_MIX_MATCH_SELECTOR).forEach(initMixMatch);
});
